export class AcceptRejectNegotiation{
    file:any;
    templateReqRelId:number;
    templateTypeId:number;
    comment:string;
    processTemplateReqRelId:number;
    processId :number;
    PaymentAmount:number;
    userMail:string;
    templateTypeName:string;
    partyName:string;
    alignment:number;
    confirmWithCommercial:boolean;
    nextStep:number;

}